export const UPLOAD_MODE = "upload" as const;
export const LINK_MODE = "link" as const;
export const UPLOAD_OR_LINK_MODES = [UPLOAD_MODE, LINK_MODE] as const;
export type UploadOrLinkMode = (typeof UPLOAD_OR_LINK_MODES)[number];

export const MODE_CONTROL_DROPDOWN = "dropdown" as const;
export const MODE_CONTROL_RADIO = "radio" as const;
export type UploadOrLinkModeControl =
  | typeof MODE_CONTROL_DROPDOWN
  | typeof MODE_CONTROL_RADIO;

// the documents live under the field key, the link and chosen mode under derived keys
export const LINK_KEY_SUFFIX = "__link";
export const MODE_KEY_SUFFIX = "__mode";
